import React, {useEffect, useState} from "react";
import axios from "axios";

const MarketStockHeader = ({ symbol }) => {
  const [symbol1Data, setSymbol1Data] = useState(undefined);
  const [symbol2Data, setSymbol2Data] = useState(undefined);

  const symbol_1 = symbol['symbol_1'];
  const symbol_2 = symbol['symbol_2'];
  const stockExcName = {[symbol_2]: 'WSE', [symbol_1]: 'BME'};

  useEffect(() => {
    getDataFromApi(symbol_1);
    getDataFromApi(symbol_2);
  }, []);

  function getDataFromApi(symbol) {
    let requests = [];
    let responses = {};
    const language = drupalSettings.path.currentLanguage || '';

    requests.push(axios.get(`/` + language + `/api/market/${symbol}/intraday/last`));
    requests.push(axios.get(`/` + language + `/api/market/${symbol}/performance`));
    requests.push(axios.get(`/` + language + `/api/market/${symbol}`));
    axios.all(requests).then(axios.spread((...resp) => {
      responses = resp.map(val => {
        return val.data
      });
      switch (symbol) {
        case symbol_1:
          setSymbol1Data(responses);
          break;
        case symbol_2:
          setSymbol2Data(responses);
          break;
      }
    })).catch(errors => console.error(errors));
  }

  function getValue(symbol, valueType) {
    let data;
    switch (symbol) {
      case symbol_1:
        data = symbol1Data;
        break;
      case symbol_2:
        data = symbol2Data;
        break;
    }

    if (data) {
      switch (valueType) {
        case 'marketCap':
          return Number(Math.round((data[2].market_cap/1000000) * 100) / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ');
        case 'price':
          return data[0].price;
        case 'nominal':
          return (Math.round(data[1].intraday.last.nominal * 100) / 100);
        case 'relative':
          return data[1].intraday.last.relative * 100;
      }
    } else {
      return '';
    }
  }

  function getCurrency(symbol) {
    let data;
    switch (symbol) {
      case symbol_1:
        data = symbol1Data;
        break;
      case symbol_2:
        data = symbol2Data;
        break;
    }
    return data ? data[2].currency : '';
  }

  function createIcon(value) {
    if (value > 0) return <i className="fas fa-chevron-up text-success"></i>;
    if (value < 0) return <i className="fas fa-chevron-down text-danger"></i>;
  }

  function createStockElement(symbol) {
    let classes = "d-sm-inline-block pr-sm-5 pr-1na";

    if (symbol === symbol_1) {
      classes += " symbol-1";
    }
    if (symbol === symbol_2) {
      classes += " symbol-2 pl-sm-5";
    }

    const relativeChange = getValue(symbol, 'relative');
    let relativeChangeString = parseFloat(relativeChange).toFixed(2);

    if (relativeChange > 0) {
      relativeChangeString = '+' + relativeChangeString;
    }

    return <div className={classes}>
      <div className="d-inline-block stock-exc-name pr-3">{stockExcName[symbol]}</div>

      <div className="icon d-inline-block pr-2">{createIcon(getValue(symbol, 'relative'))}</div>

      <div className="d-inline-block stock pr-2">
        <span className="price pr-1">{parseFloat(getValue(symbol, 'price')).toFixed(2)}</span>
        <span className="currency small-text">{getCurrency(symbol)}</span>
      </div>

      <div className="d-inline-block intraday pr-3 small-text">
        {getValue(symbol, 'nominal')} {getCurrency(symbol)} ({relativeChangeString}%)
      </div>

      <div className="d-inline-block market-cap">
        <span className="name pr-2">MCap.</span>
        <span className="value pr-2">{getValue(symbol, 'marketCap')}</span>
        <span className="currency small-text">m{getCurrency(symbol)}</span>
      </div>
    </div>

  }


  return (
    <div className="container">
      <div className="header-stock-symbols">
      {createStockElement(symbol_1)}
      {createStockElement(symbol_2)}
      </div>
    </div>
  );
};

export default MarketStockHeader;
